import { Operator } from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import ContainsValue from './ContainsValue';

const ListMultiple = ({
  selectedOperator,
  availableValueOptions,
  fieldName,
  showLabel,
  readOnly = false
}) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
      return (
        <EqualValue
          fieldName={fieldName}
          availableValueOptions={availableValueOptions}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );

    case Operator.CONTAINS:
      return (
        <ContainsValue
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );

    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS ATTRIBUTE IS UNDEFINED*/}</>;

    default:
      return <></>;
  }
};

export default ListMultiple;
